import React from 'react';

function ColoredSquare({color = 'yellow', x= 0, y = 0}) {
    return (
        <div className={`square ${color}`} style={{top: `${y}px`, left: `${x}px`}}></div>
    );
}

export default ColoredSquare;